<script setup>
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu/index.js'
import { Button } from '@/components/ui/button/index.js'

const { t, locale, setLocale } = useT()
const languages = [
  { code: 'en', label: 'English' },
  { code: 'it', label: 'Italian' },
  { code: 'ro', label: 'Romanian' }
]

</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button variant="ghost" class="relative h-10 w-10 rounded-full">
        🌐
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-56" align="end">
      <DropdownMenuLabel>
        <div class="flex flex-col space-y-1">
          <p class="text-sm font-medium leading-none">
            <strong>{{ t('languageSwitcher.selectLanguage') }}</strong>
          </p>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem v-for="lang in languages" :key="lang.code" @click="setLocale(lang.code)">
        {{ lang.label }}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style scoped>

</style>
